<emm-management-layout>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'item_search_bar'"
        [displaySearchWithOptions]="false"
        [fields]="fields"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        layout-center-header
        (add)="openCreateItemForm()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-list
        [contextMenuActions]="itemsContextMenuActions"
        [disableContextActions]="anyLoading$ | async"
        [isReadOnly]="isReadOnly$ | async"
        [items]="items$ | async"
        layout-center-content
        (onSelectItem)="onSelectItem($event)"
    ></emm-generic-items-list>
    <emm-management-attributes-header
        *ngIf="!addClicked && !duplicateClicked && (itemDetail$ | async) as item"
        layout-right-header
        [name]="item.name"
        [tag]="item.tag"
        [type]="item.itemType"
    ></emm-management-attributes-header>
    <emm-items-form *ngIf="!addClicked && !duplicateClicked && (itemDetail$ | async)"
        #form
        layout-right-content
        [previousAttributeGroups]="previousAttributeGroups$ | async"
        (attributeGroupSelected)="onAttributeGroupSelected($event)"
    ></emm-items-form>
    <emm-management-attributes-header
        *ngIf="addClicked || duplicateClicked"
        layout-right-header
        [name]="'New Item'"
        [tag]="'TBD'"
        [type]="'TBD'"
    ></emm-management-attributes-header>
    <emm-item-creation-form *ngIf="addClicked"
        #form
        layout-right-content
        [attributes]="globalAttributes"
        [previousAttributeGroups]="previousAttributeGroups$ | async"
        (attributeGroupSelected)="onAttributeGroupSelected($event)"
        (cancelClicked)="cancelCreationOrDuplication()"
        (submissionFinished)="onCreateFinished()"
    ></emm-item-creation-form>
    <emm-item-duplication-form *ngIf="duplicateClicked && allAttributes && (itemToCopy$ | async) as itemToCopy"
                            #form
                            layout-right-content
                            [itemToCopy]="itemToCopy"
                            [allAttributes]="allAttributes"
                            [previousAttributeGroups]="previousAttributeGroups$ | async"
                            (attributeGroupSelected)="onAttributeGroupSelected($event)"
                            (cancelClicked)="cancelCreationOrDuplication()"
                            (submissionFinished)="onCreateFinished()"
    ></emm-item-duplication-form>
    <context-menu #nodeMenu [disabled]="isReadOnly">
         Delete
        <ng-template contextMenuItem (execute)="onDeleteItem(null)">
            <mat-icon>delete</mat-icon>
            <span [attr.data-testid]="'refresh_items'">Delete</span>
        </ng-template>
    </context-menu>
</emm-management-layout>
